<template>
  <div class="dashboardHeader">
    <div class="dashboardHeader-container">
      <div class="dashboardHeader-feedColor">
        <icon-com
          name="circle"
          size="large"
          :color="feedGroup.color"
        ></icon-com>
      </div>
      <div class="dashboardHeader-feedName">
        {{feedGroup.plural}}
      </div>
      <div class="dashboardHeader-addFeedGroupHolder">
        <button-com
          iconName="list-add"
          iconSize="small"
          :text="'Add new ' + feedGroup.singular"
          @click.native="addFeedGroup"
        ></button-com>
      </div>
      <div class="dashboardHeader-manageFeedHolder">
        <div class="dashboardHeader-manageFeedButtonHolder">
          <button-com
            :iconName="feedGroupPublic ? 'public' : 'private'"
            iconSize="large"
            iconCircleColor="#E0E0E0"
            :tooltip="feedGroupPublic ? `Make Private` : `Make Public`"
            class="bm-ghost bm-onlyIcon"
            @click.native="toggleFeedGroupPublic"
          ></button-com>
        </div>
        <div class="dashboardHeader-manageFeedButtonHolder">
          <button-com
            iconName="settings"
            iconSize="large"
            iconCircleColor="#E0E0E0"
            tooltip="Settings"
            class="bm-ghost bm-onlyIcon"
            @click.native="goTo('/changeCurrentFeed')"
          ></button-com>
        </div>
        <div class="dashboardHeader-manageFeedButtonHolder">
          <button-com
            iconName="delete"
            iconSize="large"
            iconCircleColor="#E0E0E0"
            tooltip="Delete"
            class="bm-ghost bm-onlyIcon"
            @click.native="deleteFeedGroup"
          ></button-com>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['feedGroup', 'feedGroupIndex'],
  computed: {
    feedGroupPublic () {
      return this.$store.state.feeds[this.feedGroupIndex][0].public
    },
    feeds () {
      return this.$store.state.feeds
    },
    currentFeed () {
      return this.$store.state.currentFeed
    }
  },
  methods: {
    goTo (link) {
      this.$router.push(link)
    },
    deleteFeedGroup () {
      const shouldDelete = confirm(`Are you sure you want to delete "${this.feedGroup.plural}" ?`)
      if (shouldDelete) {
        this.$store.commit({
          type: 'deleteFeedGroup',
          feedGroupIndex: this.feedGroupIndex
        })

        this.$http.post(
          'http://api.lootbox.se/deleteType',
          {
            id: this.feedGroup.id
          },
          {
            emulateJSON: true,
            withCredentials: true
          }
        ).then(() => {
          this.$store.commit('currentFeed', this.feeds.length - 1)
        })
      }
    },
    updateTemplate () {
      this.$store.commit({
        type: 'updateTemplate',
        feedGroupIndex: this.feedGroupIndex
      })
    },
    addFeedGroup () {
      this.$store.commit({
        type: 'addFeedGroup',
        feedGroupIndex: this.feedGroupIndex,
        template: this.feedGroup.template
      })
    },
    toggleFeedGroupPublic () {
      this.$store.commit({
        type: 'toggleFeedGroupPublic',
        feedGroupIndex: this.feedGroupIndex,
        isPublic: !this.feedGroupPublic
      })
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('dashboardHeader')
  max-width: 708px
  margin: 0 auto
  position: relative
  padding: 0 30px

  +element('container')
    height: 100px
    width: 100%
    display: flex
    align-items: center

  +element('feedColor')
    width: 40px
    height: 40px
    margin-right: 15px

  +element('feedName')
    font-size: 16px
    color: #808080

  +element('manageFeedHolder')
    position: absolute
    right: 30px
    display: flex

  +element('manageFeedButtonHolder')
    margin-left: 5px
    height: 40px

  +element('addFeedGroupHolder')
    position: absolute
    left: 50%
    transform: translateX(-50%)

</style>



// WEBPACK FOOTER //
// src/components/DashboardHeader.vue